import { Trans, useLingui } from "@lingui/react/macro";
import { useState } from "react";
import { Link } from "react-router-dom";

import { apiPutUsersForgotPassword } from "../../../api";
import { RequestError } from "../../../api/api-connector";
import { AppModel } from "../../../app/app-model";
import { genericErrorMsg } from "../../../app/common-messages";
import { Button } from "../../../components/ui-kit/button";
import { ErrorMessage } from "../../../components/ui-kit/error-message";
import { TextInput } from "../../../components/ui-kit/fields/text-input";
import { Form } from "../../../components/ui-kit/form/form";
import { SuccessMessage } from "../../../components/ui-kit/success-message";

export function ForgotPasswordRoute(props: { app: AppModel }) {
  const { t } = useLingui();
  const [email, setEmail] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async () => {
    setSuccessMessage("");
    setErrorMessage("");

    try {
      await apiPutUsersForgotPassword({
        query: {
          user_email: email,
        },
      });

      setSuccessMessage(
        t`Password reset instructions have been sent to your email.`,
      );
      setEmail("");
    } catch (error) {
      if (error instanceof RequestError) {
        if (error.response.status === 404) {
          setErrorMessage(t`No user found with this email address.`);
        } else if (error.response.status === 405) {
          setErrorMessage(
            t`Multiple accounts found with this email. Please contact support.`,
          );
        } else if (error.response.status === 406) {
          setErrorMessage(
            t`This user has a temporary password and cannot reset their password this way.`,
          );
        } else if (error.response.status === 429) {
          setErrorMessage(
            t`A reset was already requested recently. Please wait 10 minutes before trying again.`,
          );
        } else {
          setErrorMessage(t(genericErrorMsg));
        }
      } else {
        throw error;
      }
    }
  };

  return (
    <div className="grow flex items-center justify-center">
      <div className="flex flex-col w-80">
        <h2 className="text-xl font-semibold mb-11">
          <Trans>Forgot password</Trans>
        </h2>

        <Form className="flex flex-col" onSubmit={handleSubmit}>
          <div className="grid grid-cols-[max-content_1fr] gap-x-2 gap-y-3 items-center">
            <label>
              <Trans>Email address:</Trans>
            </label>
            <TextInput
              type="email"
              value={email}
              onChange={(newValue) => {
                setEmail(newValue);
              }}
              required
              autoFocus
            />
          </div>

          <ErrorMessage message={errorMessage} />
          <SuccessMessage message={successMessage} />

          <div className="flex items-center justify-between mt-6">
            <Link
              to="/login"
              className="text-xs text-brand-primary hover:underline"
            >
              <Trans>Back to login</Trans>
            </Link>

            <Button variant="primary" type="submit">
              <Trans>Send reset instructions</Trans>
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}
